import React from "react"
import Helmet from "react-helmet"

export default () => (
  <Helmet>
    <script src="https://use.fontawesome.com/releases/v5.0.6/js/solid.js" />
    <script src="https://use.fontawesome.com/releases/v5.0.6/js/fontawesome.js" />
  </Helmet>
)
